import { Modal, addToast } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';

import { AxiosResult, AxiosResultDefaultError } from '../../../api/request';
import { CampusListResponse } from '../../../api/requests/campus';
import { useLayoutState } from '../../../hooks/useLayoutState';
import CampusForm, { RecordToEditBody } from './CampusForm';

interface CampusModalProps {
  siesEnabled?: boolean;
  reloadCampusList: () => void;
  recordToEdit: RecordToEditBody | null;
  show: boolean;
  toggleModal: () => void;
}

const getTranslationsTexts = (isEditionMode: boolean) => {
  const translationPreffix = 'maintainers.campusForm';
  return isEditionMode
    ? {
        create: 'common.actions.saveChanges',
        success: 'common.messages.editSuccess',
        formTitle: 'maintainers.campusForm.editTitle',
      }
    : {
        create: `${translationPreffix}.create`,
        success: `${translationPreffix}.createSuccess`,
        formTitle: `${translationPreffix}.addTitle`,
      };
};

const CampusModal = ({
  siesEnabled = false,
  recordToEdit,
  reloadCampusList,
  show,
  toggleModal,
}: CampusModalProps) => {
  const { t } = useTranslation();
  const { showErrorModal } = useLayoutState();

  const isEditionMode = !!recordToEdit;
  const texts = getTranslationsTexts(isEditionMode);

  const onSubmit = async (
    result: AxiosResult<CampusListResponse, AxiosResultDefaultError>,
  ) => {
    const { error, data } = result;
    if (error && error.code === 'CONNECTION') {
      showErrorModal();
    } else if (error) {
      addToast({
        icon: 'error',
        color: 'danger',
        text: t('common.errors.save'),
      });
    } else if (data) {
      reloadCampusList();
      addToast({
        icon: 'success',
        color: 'success',
        text: t(texts.success),
      });
    }
  };

  return (
    <Modal isOpen={show} toggle={toggleModal} size="lg" unmountOnClose>
      <CampusForm
        recordToEdit={recordToEdit ?? undefined}
        siesEnabled={siesEnabled}
        onSubmit={onSubmit}
        onCancel={toggleModal}
      />
    </Modal>
  );
};
export default CampusModal;
